import React, { useEffect } from 'react';
import { ClickToComponent } from 'click-to-react-component';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';

import brandLogo from '@/assets/bluefocus_ai_logo_white_color.png';
import HeaderContent from '@/components/Framework/HeaderContent';
import { IdentificationProvider } from '@/components/RealnameIdentification';
import AvatarDropdown from '@/components/Framework/RightContent/AvatarDropdown';
import Settings from '../../../../config/defaultSettings';

import styles from './styles.less';
import { useModel } from 'umi';

const Header: React.FC<{
  collapsed?: boolean;
  onCollapse?: (collapsed: boolean) => void;
}> = ({ collapsed = false, onCollapse }) => {
  const { initialState } = useModel('@@initialState');
  const { fetchFeatureData } = useModel('useFeature');

  /** 加载灰度列表：此组件一定会渲染，可在此监听是否登录过，从而决定去加载全局的灰度列表 */
  useEffect(() => {
    // 因为 username 展示的是邮箱，所以可通过此字段来判断是否登录
    if (initialState?.currentUser?.username) {
      fetchFeatureData();
    }
  }, [fetchFeatureData, initialState, initialState?.currentUser]);

  if (!initialState || !initialState.settings) {
    return null;
  }

  return (
    <IdentificationProvider>
      {/* 本地快速定位项目代码，需要在一个每个页面渲染的位置，故加在此 */}
      <ClickToComponent />
      <div className={styles['layout-header-container']}>
        <div className={styles['header-left']}>
          {/* 公司标（BlueFocusAI）+ 分隔线 + 产品名，双品牌 lockup */}
          <div className={styles['brand-lockup']}>
            <img className={styles['header-logo']} src={brandLogo} alt='BlueFocusAI' />
            <span className={styles['brand-divider']} />
            <div className={styles['project-title']}>{Settings.title}</div>
          </div>
          {collapsed && onCollapse && (
            <div className={styles['collapse-trigger']} onClick={() => onCollapse(!collapsed)}>
              {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </div>
          )}
        </div>
        <div className={styles['header-right-content']}>
          <HeaderContent />
          <AvatarDropdown />
        </div>
      </div>
    </IdentificationProvider>
  );
};

export default Header;
